const envObj = process.env;

let API_URL_Temp = envObj.REACT_APP_API_URL as string;
// API_URL_Temp += API_URL_Temp.endsWith("/") ? "" : "/";

export const API_URL = API_URL_Temp;

export const URL = (path: string) => {

  const newPath = path.replace(/^\/|\/$/g, '');

  return `${API_URL}${newPath}`;
};
